import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { mattressOptionList, PlumberFormData } from "../../../types/plumber";
import { getMattressReceiptDetail } from "../../../API/AppRepository";
import MattressDetailBasicInfo from "./mattressDetailBasicInfo";
import MattressDetailExportInfo from "./mattressDetailExportInfo";
import { useNavigate, useParams } from "react-router-dom";

const Container = styled.div`
  margin: 0 auto;

  /* 모바일*/
  @media (max-width: 767px) {
    border-radius: 12px;
    font-size: 12px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 32px;
    border-radius: 12px;
    font-size: 18px;
  }

  /* PC */
  @media (min-width: 1200px) {
    padding: 30px 900px;
    border-radius: 12px;
    font-size: 20px;
  }
`;
const Page = styled.div`
  background: #fff;
  max-width: 100%;
  margin: 0 auto;

  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 16px;
    padding: 20px;
    font-weight: 500;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    border-radius: 0px 0px 12px 12px;
    font-size: 18px;
    padding: 50px;
    font-weight: 700;
  }

  /* PC */
  @media (min-width: 1200px) {
    border-radius: 0px 0px 12px 12px;
    font-size: 20px;
    padding: 50px;
    font-weight: 700;
  }
`;
const TabWrapper = styled.div`
  display: flex;
  gap: 20px;
`;
const Tab = styled.button<{ $active: boolean }>`
  flex: 1;

  background: ${({ $active }) => ($active ? "#0C8CE9" : "#f2f2f2")};
  color: ${({ $active }) => ($active ? "#fff" : "#aaa")};
  border: none;
  cursor: pointer;
  /* 모바일*/
  @media (max-width: 767px) {
    border-radius: 8px 8px 0 0;
    font-size: 14px;
    padding: 8px 0;
    font-weight: 500;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    border-radius: 12px 12px 0 0;
    font-size: 18px;
    padding: 16px 0;
    font-weight: 700;
  }

  /* PC */
  @media (min-width: 1200px) {
    border-radius: 12px 12px 0 0;
    font-size: 20px;
    padding: 16px 0;
    font-weight: 700;
  }
`;

export default function MattressDetailComponent<
  T extends Record<string, any>
>() {
  //   const serverData = plumberBody;
  const { id } = useParams();

  const [form, setForm] = useState<PlumberFormData>({
    name: "",
    status: "",
    contact: "",
    itemCode: "",
    address: "",
    addressDetail: "",
    zipCode: "",
    workDate: "",
    totalPrice: 0,
    memo: "",
    options: [],
  });

  const [tab, setTab] = useState<"info" | "export">("info");
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [optionPrices, setOptionPrices] = useState<Record<string, string>>({});

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        if (!id) return;
        const data = await getMattressReceiptDetail(id);

        if (!data) return;

        // 1. form 데이터 세팅
        setForm({
          name: data.name ?? "",
          status: data.status ?? "",
          contact: data.contact ?? "",
          itemCode: data.itemCode ?? "",
          address: data.address ?? "",
          addressDetail: data.addressDetail ?? "",
          zipCode: data.zipCode ?? "",
          workDate: data.workDate ?? "",
          totalPrice: data.totalPrice ?? 0,
          memo: data.memo ?? "",
          options: data.options ?? [],
        });

        // 2. 옵션 처리
        const selected: string[] = [];
        const prices: Record<string, string> = {};

        data.options?.forEach((opt: any) => {
          selected.push(opt.name);
          prices[opt.name] = opt.price.toString();
        });

        setSelectedOptions(selected);
        setOptionPrices(prices);
      } catch (error) {
        console.error("디테일 불러오기 실패", error);
      }
    };

    fetchDetail();
  }, [id]);

  useEffect(() => {
    const total = Object.values(optionPrices)
      .map((v) => Number(v) || 0)
      .reduce((acc, cur) => acc + cur, 0);

    setForm((prev) => ({
      ...prev,
      totalPrice: total,
    }));
  }, [optionPrices]);

  const optionList = mattressOptionList;

  return (
    <Container>
      <TabWrapper>
        <Tab $active={tab === "info"} onClick={() => setTab("info")}>
          1. 기본 정보
        </Tab>
        <Tab $active={tab === "export"} onClick={() => setTab("export")}>
          2. 견적서 내보내기
        </Tab>
      </TabWrapper>
      <Page>
        {tab === "info" && (
          <MattressDetailBasicInfo
            form={form}
            setForm={setForm}
            optionList={optionList}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            optionPrices={optionPrices}
            setOptionPrices={setOptionPrices}
            onOpenDateModal={() => setIsModalOpen(true)}
          />
        )}
        {tab === "export" && (
          <MattressDetailExportInfo
            form={form}
            options={selectedOptions.map((label) => ({
              label,
              size: 1,
              price: Number(optionPrices[label] || 0),
            }))}
          />
        )}
      </Page>
    </Container>
  );
}
